// extracted by mini-css-extract-plugin
module.exports = {"container":"configureStyles_container__2-KO-","checkboxContainer":"configureStyles_checkboxContainer__13dkl","actionBtnContainer":"configureStyles_actionBtnContainer__1QxTw"};